module.exports = __webpack_public_path__ + "img/death-artist.507cc304.png";